<ng-container *ngrxLet="isInAemPreviewMode$ as isInAemPreviewMode">
  <!-- dir attribute is mandatory for workbench. allowed currently just 'ltr' and 'rtl', not 'auto' -->
  <div
    class="cc-app"
    [attr.data-theme]="theme$ | async"
    [ngClass]="{ 'cc-app--in-aem-context': isInAemPreviewMode }"
    dir="ltr"
  >
    <div class="cc-app-top-of-page" tabindex="-1"></div>
    <ng-container *ngIf="isInAemPreviewMode; then appPlaceholder; else app" />
  </div>
</ng-container>
<ng-template #appPlaceholder> <cc-lazy-host [componentId]="appPlaceholderComponent" /> </ng-template>
<ng-template #app>
  <cc-app-container> <router-outlet /> </cc-app-container> <cc-loading-status-indicator />
  <cc-loading-spinner *ngIf="isLoading$ | async" /> <cc-notification position="bottom-end" theme="light" />
  <!--
    consent container (container for Usercentrics CMP version 2,
    which will just be displayed by OWCC in standalone mode)
  -->
  <cc-consent-container /> <cc-dev />
</ng-template>
